<template>
<div class='vx-col w-full mt-4'>
    <section>
        <div class="text-right" style="margin-top: -25px; ">
            <span style="border: 1px solid #e5e5e5" class="p-2">
                <i class="mr-2 fa fa-th-large cursor-pointer" :class="tipo_vista == 0 ? 'text-primary': ''" aria-hidden="true" @click="f_change_view(0)"></i>
                <i class="ml-2 fa fa-list cursor-pointer" :class="tipo_vista == 1 ? 'text-primary': ''" aria-hidden="true" @click="f_change_view(1)"></i>
            </span>
        </div>
    </section>
    <section class="lista-evaluaciones-docente" v-if="tipo_vista==0">
        <transition name="fade">
            <vs-row>
                <vs-col vs-lg="4" vs-sm="6" vs-md="4" vs-xs="12" :key="indextr" v-for="(tr, indextr) in arrayEvaluaciones">
                    <div class="card m-2">
                        <div class="bordes">
                            <vs-col vs-w="12">
                                <img :src="require('@/assets/images/evaluacion/header-evaluacion.svg')" alt="Evaluaciones AZ">
                            </vs-col>
                            <vs-divider></vs-divider>
                            <vs-col vs-w="12" class="m-4">
                                <h3 v-if="tr.libro"><b><i>{{ tr.libro.nombrelibro }} </i></b> </h3>
                                <p v-if="tr.curso.estado == 0" class="text-danger"><b>CURSO DESACTIVADO</b> <br/><small>El estudiante no puede acceder a este desafío</small> </p>
                            </vs-col>
                            <vs-divider></vs-divider>
                            <vs-col vs-w="6" vs-xs="12">
                                <div class="card-content">
                                    <p class="mt-1">Código curso:</p>
                                    <p><b class="text-primary">{{ tr.codigo_curso }}</b></p>
                                    <p class="mt-1">Puntaje: <span><br> <b>{{ tr.puntaje }}</b></span> </p>
                                    <p class="mt-1">Origen preguntas: <br>
                                        <span v-if="tr.origen == 0"> <b>Desafios AZ</b></span>
                                        <span v-else><b> Mis desafíos</b></span>
                                    </p>
                                    <p class="mt-1">Unidades:<span><br><b> {{ tr.unidades }}</b></span></p>
                                </div>
                            </vs-col>
                            <vs-col vs-w="6">
                                <div class="card-content">
                                    <p><b>Inicio:</b> {{ tr.fecha_inicio }}</p>
                                    <p><b>Fin:</b> {{ tr.fecha_fin }}</p>
                                </div>
                            </vs-col>
                            <vs-col vs-w="12">
                                <div class="card-content">
                                    <b>Indicaciones:</b>
                                    <p>{{ tr.indicaciones.substring(0,50) }}</p>
                                    <p>
                                        <vs-chip v-if="tr.estado == 1" color="success">Activo</vs-chip>
                                        <vs-chip v-else color="warning">Desactivado</vs-chip>
                                    </p>
                                </div>
                            </vs-col>
                            <vs-divider></vs-divider>
                            <vs-col vs-w="12">
                                <div class="card-content">
                                    <vs-button type="border" icon="edit" color="warning" class="vs-button inline m-2" @click="$emit('changeHandle',1,tr)">Editar</vs-button>
                                    <vs-button type="border" icon="grade" color="primary" class="vs-button inline m-2" @click="$emit('changeHandle',3,tr)">Calificaciones</vs-button>
                                </div>
                            </vs-col>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </transition>
    </section>
    <section class="lista-evaluaciones-docente" v-if="tipo_vista==1">
        <transition name="fade">
            <vs-table stripe search :data="arrayEvaluaciones" no-data-text="No tiene evaluaciones creadas para el periodo actual" class="mt-5">
                <template slot="thead">
                    <vs-th width="50%" sort-key="evaluacion">Evaluación</vs-th>
                    <vs-th sort-key="id_tipo_pregunta">Fechas</vs-th>
                    <vs-th sort-key="id_tipo_pregunta">Acciones</vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].nombre_unidad">
                            #{{ tr.id }}
                            <p v-if="tr.libro"><b>Libro:</b> <span> {{ tr.libro.nombrelibro }}</span> </p>
                            <p v-if="tr.curso.estado == 0" class="text-danger"><b>CURSO DESACTIVADO</b><br> <small> El estudiante no puede acceder a este desafío</small> </p>
                            <p class="mt-1"><b>Puntaje:</b> <span> {{ tr.puntaje }}</span> </p>
                            <p class="mt-1"><b>Código curso:</b><span> {{ tr.codigo_curso }}</span></p>
                            <p class="mt-1"><b>Origen preguntas:</b>
                                <span v-if="tr.origen == 0"> Desafios AZ</span>
                                <span v-else> Mis desafíos</span>
                            </p>
                            <b class="mt-1">Indicaciones:</b>
                            <p>{{ tr.indicaciones }}</p>
                            <p class="mt-1"><b>Unidades:</b><span> {{ tr.unidades }}</span></p>
                        </vs-td>
                        <vs-td>
                            <p><b>Inicio:</b> {{ tr.fecha_inicio }}</p>
                            <p class="mt-1"><b>Fin:</b> {{ tr.fecha_fin }}</p>
                            <vs-chip v-if="tr.estado == 1" color="success">Activo</vs-chip>
                            <vs-chip v-else color="warning">Desactivado</vs-chip>
                        </vs-td>
                        <vs-td>
                            <vs-dropdown vs-custom-content vs-trigger-click>
                                <a class="a-icon cursor-pointer" href.prevent>
                                    <vs-button type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>
                                </a>

                                <vs-dropdown-menu>
                                    <vs-dropdown-item>
                                        <vs-button style="width: 200px" type="line" icon="edit" color="warning" class="vs-button" @click="$emit('changeHandle',1,tr)">Editar</vs-button>
                                    </vs-dropdown-item>
                                    <vs-dropdown-item>
                                        <vs-button style="width: 200px" icon="grade" type="line" color="primary" class="vs-button" @click="$emit('changeHandle',3,tr)">Calificaciones</vs-button>
                                    </vs-dropdown-item>
                                </vs-dropdown-menu>
                            </vs-dropdown>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </transition>
    </section>
    <section class="calificaciones">
        <vs-popup title="Calificaciones" :active.sync="modalCalificaciones">
            <Lista_calificaciones :enviar_datos="enviar_datos" />
        </vs-popup>
    </section>
</div>
</template>

<script>
import Lista_calificaciones from './lista_calificaciones.vue';
export default {
    components: {
        Lista_calificaciones
    },
    data() {
        return {
            modalCalificaciones: false,
            enviar_datos: {},
            tipo_vista: ''
        };
    },
    created() {},
    mounted() {
        let me = this;
        me.tipo_vista = JSON.parse(localStorage.getItem("tipo_vista"))
        if (me.tipo_vista == null) {
            me.tipo_vista = 0;
        }
        console.log(me.tipo_vista)
    },
    props: {
        arrayEvaluaciones: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        f_calificaciones(e) {
            let me = this;
            console.log(e)
            me.enviar_datos = e
            me.modalCalificaciones = true;
        },
        f_change_view(e) {
            let me = this;
            me.tipo_vista = e;
            localStorage.setItem("tipo_vista", me.tipo_vista);
        }
    }
};
</script>

<style scoped>
.card {
    display: inline-block;
    width: 100%;
}

.bordes {
    margin: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.card img {
    width: 100%;
    height: auto;
}

.card-content {
    padding: 15px;
}

.card-content h2 {
    margin-top: 0;
}

.card-content p {
    margin-bottom: 0;
}
</style>
